import Swiper from 'swiper';
import { Navigation, Pagination, Controller, A11y, Autoplay, EffectFade } from "swiper/modules";
Swiper.use([Navigation, Pagination, Controller, A11y, Autoplay, EffectFade]);
import { gsap } from "gsap";

window.gsap = gsap
const body = document.body

const debounce = (callback, wait) => {
	let timeoutId = null;
	return (...args) => {
		window.clearTimeout(timeoutId);
		timeoutId = window.setTimeout(() => {
			callback.apply(null, args);
		}, wait);
	};
}

const animations = {
	init: function (matchMedia) {

	}
}

const navigation = {
	init: function (matchMedia) {
		const siteNavigation = document.getElementById('site-nav')

		if (siteNavigation) {
			const siteNavigationOverlay = document.getElementById('site-nav-overlay')
			const toggleNavigationButton = document.getElementById('site-nav-toggle')
			const siteNavigationElements = siteNavigation.querySelectorAll('.site-nav__menu > li')
			const siteNavigationFoot = siteNavigation.querySelector('.site-nav__lang')
			let navigationShown = false
			let scrollPosition = 0

			toggleNavigationButton.addEventListener('click', function () {
				if (!navigationShown) {
					showNavigation()
				} else {
					hideNavigation()
				}
			})

			document.addEventListener('click', function (event) {
				if (navigationShown) {
					const isClickInside = siteNavigation.contains(event.target) || toggleNavigationButton.contains(event.target)

					if (!isClickInside) {
						hideNavigation()
					}
				}
			})

			const openTl = gsap.timeline({ paused: true })
			gsap.set(siteNavigation, { y: '-100%', autoAlpha: 0 })
			openTl.add(gsap.to(siteNavigationOverlay, { autoAlpha: 1, duration: 0.2, ease: 'none' }))
			openTl.add(gsap.to(siteNavigation, { y: '0%', autoAlpha: 1, duration: 0.35 }), '-=0.2')

			function showNavigation() {
				scrollPosition = window.scrollY
				openTl.restart()
				openTl.resume()
				toggleNavigationButton.setAttribute('aria-expanded', 'true')
				navigationShown = true
				body.classList.add('is-site-nav-open')
				body.style.top = -scrollPosition + 'px'

				gsap.fromTo(
					siteNavigationElements,
					{ autoAlpha: 0, y: '-30px', scale: 0.95 },
					{ autoAlpha: 1, y: '0', scale: 1, duration: 0.35, delay: 0.2, ease: 'power2.out', stagger: 0.075 }
				)
				gsap.fromTo(siteNavigationFoot, { autoAlpha: 0, scale: 0.95 }, { autoAlpha: 1, scale: 1, duration: 0.35, delay: 0.5 })
			}

			function hideNavigation() {
				body.classList.remove('is-site-nav-open');
				body.style.top = 0;
				window.scrollTo(0, scrollPosition);
				openTl.reverse()
				openTl.resume()
				toggleNavigationButton.setAttribute('aria-expanded', 'false')
				navigationShown = false
			}
			window.hideNavigation = hideNavigation
		}
	},

	setupDropdown: function (matchMedia) {
		matchMedia.add('screen and (min-width: 64em)', function () {
			const topBarMenuItems = document.querySelectorAll('.top-bar__menu > li.menu-item-has-children')
			let currentOpenDropdown = null
			let openTimeout = null
			let closeTimeout = null

			// Function to open the dropdown
			function openDropdown(dropdown, isDropdownAnchorPresent) {
				if (currentOpenDropdown && currentOpenDropdown !== dropdown) {
					closeDropdown(currentOpenDropdown)
				}

				dropdown.style.zIndex = 10

				if (currentOpenDropdown === dropdown) return

				gsap.killTweensOf(dropdown) // Stop any ongoing animations

				gsap.to(dropdown, {
					duration: 0.25,
					autoAlpha: 1,
					ease: 'power1.in',
					onStart: () => {
						if (isDropdownAnchorPresent) isDropdownAnchorPresent.classList.add('is-open')
						const anchors = dropdown.querySelectorAll('.sub-menu li')
						gsap.fromTo(
							anchors,
							{
								y: '20px',
								autoAlpha: 0
							},
							{
								duration: 0.3,
								autoAlpha: 1,
								y: 0,
								stagger: 0.05,
								ease: 'power2.out'
							}
						)

						anchors.forEach((anchor) => {
							anchor.addEventListener('click', () => closeDropdown(dropdown))
						})
					}
				})
				currentOpenDropdown = dropdown
			}

			function closeDropdown(dropdown) {
				gsap.killTweensOf(dropdown)
				const isDropdownAnchorPresent = dropdown.previousElementSibling

				gsap.to(dropdown, {
					duration: 0.25,
					autoAlpha: 0,
					ease: 'power2.in',
					onStart: () => {
						if (isDropdownAnchorPresent) isDropdownAnchorPresent.classList.remove('is-open')
						dropdown.style.zIndex = ''
					}
				})
				if (currentOpenDropdown === dropdown) currentOpenDropdown = null
			}

			topBarMenuItems.forEach((item) => {
				item.addEventListener('mouseenter', function () {
					const dropdown = this.querySelector('.sub-menu')
					const isDropdownAnchorPresent = this.querySelector('a.is-dropdown')

					if (dropdown && isDropdownAnchorPresent) {
						clearTimeout(closeTimeout)

						openTimeout = setTimeout(() => {
							openDropdown(dropdown, isDropdownAnchorPresent)
						}, 150)
					}
				})

				item.addEventListener('mouseleave', function () {
					const dropdown = this.querySelector('.sub-menu')
					if (dropdown) {
						clearTimeout(openTimeout);
						closeTimeout = setTimeout(() => {
							closeDropdown(dropdown)
						}, 100)
					}
				})
			})
		})
	},

	setupAccordion: function (matchMedia) {
		const menuItems = document.querySelectorAll('.accordion-menu .is-dropdown')

		menuItems.forEach((item) => {
			item.addEventListener('click', function (e) {
				e.preventDefault()

				document.querySelectorAll('.accordion-menu > li > .sub-menu.is-open').forEach((subMenu) => {
					if (subMenu !== item.nextElementSibling) {
						subMenu.classList.remove('is-open')
						gsap.to(subMenu, { autoAlpha: 0, height: 0, margin: 0, duration: 0.3, ease: 'power2.out' })
						gsap.set(subMenu, { display: 'none', delay: 0.3 })
					}
				})

				const subMenu = item.nextElementSibling
				if (subMenu.classList.contains('is-open')) {
					item.classList.remove('is-open')
					subMenu.classList.remove('is-open')
					gsap.to(subMenu, { autoAlpha: 0, height: 0, margin: 0, duration: 0.3, ease: 'power2.out' })
					gsap.set(subMenu, { display: 'none', delay: 0.3 })
				} else {
					item.classList.add('is-open')
					subMenu.classList.add('is-open')
					gsap.set(subMenu, { display: 'block' })
					gsap.to(subMenu, { autoAlpha: 1, height: 'auto', margin: '0.75rem 0 0', duration: 0.5, ease: 'power2.out' })
				}
			})
		})

		function closeAllAccordions() {
			document.querySelectorAll('.accordion-menu .sub-menu.is-open').forEach((subMenu) => {
				subMenu.classList.remove('is-open')
				gsap.to(subMenu, { autoAlpha: 0, height: 0, margin: 0, duration: 0.3, ease: 'power2.out' })
				// gsap.set(subMenu, { display: 'none', delay: 0.3 })
			})
			menuItems.forEach((item) => {
				item.classList.remove('is-open')
			})
		}
		window.closeAllAccordions = closeAllAccordions
	},

	hashLinks: function (matchMedia) {
		const hashLinks = document.querySelectorAll('a[href^="#"]');
		hashLinks.forEach(a => {
			if (a.getAttribute("href") === "#") return;

			const targetId = a.getAttribute('href').substring(1);
			const targetElement = document.querySelector(a.getAttribute("href"));

			if (targetElement) {
				a.addEventListener("click", e => {
					let offset = window.matchMedia("(min-width: 64em)") ? -104 : -96;
					e.preventDefault();
					document.documentElement.scrollTo({
						top: targetElement.offsetTop + offset + 1,
						behavior: 'smooth'
					});
				});
			}
		});

		// Scroll to hash on load.
		if (window.location.hash) {
			const targetElement = document.getElementById(window.location.hash.substring(1));
			let offset = window.matchMedia("(min-width: 64em)") ? -104 : -96;
			if (targetElement) {
				setTimeout(() => {
					document.documentElement.scrollTo({
						top: targetElement.offsetTop + offset + 1,
						behavior: 'smooth'
					});
				}, 150);
			}
		}
	},

	stickyTopbar: function (matchMedia) {
		const topBar = document.querySelector('.top-bar');
		const triggerPoint = document.createElement('div');

		// Add the trigger point element dynamically
		triggerPoint.style.height = '1px';
		triggerPoint.style.position = 'absolute';
		triggerPoint.style.top = '5rem';
		document.body.appendChild(triggerPoint);

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					topBar.classList.remove('has-bg');
				} else {
					topBar.classList.add('has-bg');
				}
			},
			{ threshold: [0, 1] }
		);
		observer.observe(triggerPoint);
	}
}

const offCanvas = {
	// Configuration 
	config: {
		openClass: 'is-open',
		visibleClass: 'is-visible',
		animatingClass: 'is-animating',
		transitionDuration: 300, // in ms, should match CSS transition
		overlayClass: 'off-canvas__overlay',
		closeButtonSelector: '[data-close]',
		toggleButtonSelector: '[data-offcanvas-toggle]',
		bodyClass: 'is-off-canvas-open'
	},

	// Store active panels
	activePanels: [],

	/**
	 * Initialize off-canvas panels
	 */
	init: function () {
		// Set initial ARIA attributes on all off-canvas panels and create overlays
		const panels = document.querySelectorAll('.off-canvas');
		panels.forEach(panel => this.initializePanel(panel));

		// Add event listeners for toggle buttons
		const toggleButtons = document.querySelectorAll(this.config.toggleButtonSelector);
		toggleButtons.forEach(button => button.addEventListener('click', this.handleToggleClick.bind(this)));

		// Add event listeners for close buttons
		const closeButtons = document.querySelectorAll(this.config.closeButtonSelector);
		closeButtons.forEach(button => button.addEventListener('click', this.handleCloseClick.bind(this)));

		// Add keyboard event listener for Escape key
		document.addEventListener('keydown', this.handleKeyDown.bind(this));

		let scrollPosition = 0
	},

	/**
	 * Initialize a single panel with proper ARIA attributes and create overlay
	 */
	initializePanel(panel) {
		// Set ARIA attributes
		panel.setAttribute('aria-hidden', 'true');
		panel.setAttribute('role', 'dialog');

		if (!panel.hasAttribute('aria-labelledby') && !panel.hasAttribute('aria-label')) {
			// If no label is defined, use the first heading as the label
			const heading = panel.querySelector('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6');
			if (heading) {
				const headingId = heading.id || `offcanvas-heading-${panel.id}`;
				heading.id = headingId;
				panel.setAttribute('aria-labelledby', headingId);
			} else {
				// Fallback to a generic label
				panel.setAttribute('aria-label', 'Off-canvas panel');
			}
		}

		// Create and append overlay for this panel if it doesn't exist
		let overlay = document.querySelector(`.${this.config.overlayClass}[data-for="${panel.id}"]`);
		if (!overlay) {
			overlay = document.createElement('div');
			overlay.className = this.config.overlayClass;
			overlay.setAttribute('data-for', panel.id);
			overlay.setAttribute('aria-hidden', 'true');
			document.body.appendChild(overlay);

			// Add click event listener to the overlay
			overlay.addEventListener('click', () => this.closePanel(panel));
		}
	},

	/**
	 * Handle toggle button clicks
	 */
	handleToggleClick(event) {
		const button = event.currentTarget;
		const panelId = button.getAttribute('data-offcanvas-toggle');
		const panel = document.getElementById(panelId);

		if (!panel) {
			console.error(`Off-canvas panel with id "${panelId}" not found.`);
			return;
		}

		// Toggle panel state
		if (panel.classList.contains(this.config.openClass)) {
			this.closePanel(panel);
		} else {
			this.openPanel(panel);
		}

		// Prevent default action
		event.preventDefault();
	},

	/**
	 * Handle close button clicks
	 */
	handleCloseClick(event) {
		const closeButton = event.currentTarget;
		const panel = closeButton.closest('.off-canvas');

		if (panel) {
			this.closePanel(panel);
		}

		// Prevent default action
		event.preventDefault();
	},

	/**
	 * Handle keyboard events
	 */
	handleKeyDown(event) {
		// Close panel on Escape key
		if (event.key === 'Escape' && this.activePanels.length > 0) {
			// Close the most recently opened panel
			const lastPanel = this.activePanels[this.activePanels.length - 1];
			this.closePanel(lastPanel);
		}
	},

	/**
	 * Open a specific panel
	 */
	openPanel(panel) {
		// Add to active panels list
		if (!this.activePanels.includes(panel)) {
			this.activePanels.push(panel);
		}

		// Lock body scroll position and remember current scroll position
		this.scrollPosition = window.scrollY
		body.classList.add(this.config.bodyClass);
		body.style.top = -this.scrollPosition + 'px';

		// Show panel
		panel.classList.add(this.config.animatingClass);
		panel.setAttribute('aria-hidden', 'false');

		// Show overlay for this panel
		const overlay = document.querySelector(`.${this.config.overlayClass}[data-for="${panel.id}"]`);
		if (overlay) {
			overlay.classList.add(this.config.visibleClass);
			overlay.setAttribute('aria-hidden', 'false');
		}

		// Add open class after a small delay to trigger animation
		setTimeout(() => {
			panel.classList.add(this.config.openClass);

			// Focus the first focusable element
			this.focusFirstElement(panel);
		}, 10);

		// Remove animating class after transition completes
		setTimeout(() => {
			panel.classList.remove(this.config.animatingClass);
		}, this.config.transitionDuration);

		// Update toggle buttons that control this panel
		const toggles = document.querySelectorAll(`[data-offcanvas-toggle="${panel.id}"]`);
		toggles.forEach(toggle => toggle.setAttribute('aria-expanded', 'true'));
	},

	/**
	 * Close a specific panel
	 */
	closePanel(panel) {
		if (!panel) return;

		// Start closing animation
		panel.classList.add(this.config.animatingClass);
		panel.classList.remove(this.config.openClass);

		// Unlock body scroll position and restore previous scroll position
		body.classList.remove(this.config.bodyClass);
		body.style.top = 0;
		window.scrollTo(0, this.scrollPosition);

		// Hide overlay for this panel
		const overlay = document.querySelector(`.${this.config.overlayClass}[data-for="${panel.id}"]`);
		if (overlay) {
			overlay.classList.remove(this.config.visibleClass);
			overlay.setAttribute('aria-hidden', 'true');
		}

		// Find the toggle button that opened this panel
		const toggles = document.querySelectorAll(`[data-offcanvas-toggle="${panel.id}"]`);
		let toggleToFocus = null;

		toggles.forEach(toggle => {
			toggle.setAttribute('aria-expanded', 'false');
			if (!toggleToFocus) toggleToFocus = toggle;
		});

		// Complete panel closing after animation
		setTimeout(() => {
			panel.classList.remove(this.config.animatingClass);
			panel.setAttribute('aria-hidden', 'true');

			// Return focus to the toggle button that opened the panel
			if (toggleToFocus && (document.activeElement === document.body ||
				panel.contains(document.activeElement))) {
				toggleToFocus.focus();
			}

			// Remove from active panels list
			this.activePanels = this.activePanels.filter(p => p !== panel);
		}, this.config.transitionDuration);
	},

	/**
	 * Close all open panels
	 */
	closeAllPanels() {
		// Create a copy of activePanels to avoid issues when modifying the array
		const panelsToClose = [...this.activePanels];
		panelsToClose.forEach(panel => this.closePanel(panel));
	},

	/**
	 * Focus the first focusable element in the panel
	 */
	focusFirstElement(panel) {
		const focusableElements = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
		if (focusableElements.length > 0) {
			focusableElements[0].focus();
		}
	}
};

const tabs = {
	init: function () {
		const tabSets = document.querySelectorAll('.tabs');

		tabSets.forEach(tabSet => {
			const tabList = tabSet.querySelector('[role="tablist"]');
			if (!tabList) return;

			const tabs = tabList.querySelectorAll('[role="tab"]');
			const panels = tabSet.querySelectorAll('[role="tabpanel"]');

			tabs.forEach(tab => {
				tab.addEventListener('click', e => this.changeTab(e, tabs, panels));
				tab.addEventListener('keydown', e => this.handleTabKeydown(e, tabs, panels));
			});

			let activeTabFound = false;
			tabs.forEach(tab => {
				if (tab.getAttribute('aria-selected') === 'true') {
					activeTabFound = true;
					tab.setAttribute('tabindex', '0');
				} else {
					tab.setAttribute('tabindex', '-1');
				}
			});

			if (!activeTabFound && tabs.length > 0) {
				tabs[0].setAttribute('aria-selected', 'true');
				tabs[0].setAttribute('tabindex', '0');

				const firstPanelId = tabs[0].getAttribute('aria-controls');
				if (firstPanelId) {
					const firstPanel = document.getElementById(firstPanelId);
					if (firstPanel) {
						firstPanel.setAttribute('aria-hidden', 'false');
					}
				}
			}
		});
	},

	changeTab: function (event, tabs, panels) {
		const targetTab = event.currentTarget;
		const targetPanelId = targetTab.getAttribute('aria-controls');
		const targetPanel = targetPanelId ? document.getElementById(targetPanelId) : null;

		if (!targetPanel) return;

		tabs.forEach(tab => {
			tab.setAttribute('aria-selected', 'false');
			tab.setAttribute('tabindex', '-1');
		});

		panels.forEach(panel => {
			panel.setAttribute('aria-hidden', 'true');
		});

		targetTab.setAttribute('aria-selected', 'true');
		targetTab.setAttribute('tabindex', '0');
		targetPanel.setAttribute('aria-hidden', 'false');

		targetTab.focus();
	},

	handleTabKeydown: function (event, tabs, panels) {
		const tabsArray = Array.from(tabs);
		const index = tabsArray.indexOf(event.currentTarget);
		let targetTab;

		switch (event.key) {
			case 'ArrowRight':
				targetTab = tabsArray[(index + 1) % tabsArray.length];
				break;
			case 'ArrowLeft':
				targetTab = tabsArray[index === 0 ? tabsArray.length - 1 : index - 1];
				break;
			case 'Home':
				targetTab = tabsArray[0];
				break;
			case 'End':
				targetTab = tabsArray[tabsArray.length - 1];
				break;
			default:
				return;
		}

		if (targetTab) {
			event.preventDefault();
			targetTab.click();
		}
	}
};

const swipers = {
	init: function (matchMedia) {
		const swiperCardsElements = document.querySelectorAll('.swiper--cards');
		swiperCardsElements.forEach((swiperElement) => {
			const section = swiperElement.closest('.section');
			const swiperCards = new Swiper(swiperElement, {
				slidesPerView: 'auto',
				spaceBetween: 16,
				loop: false,
				pagination: {
					el: section.querySelector(".swiper-pagination"),
					clickable: true,
				},
				breakpoints: {
					1024: {
						spaceBetween: 24,
						slidesPerView: 3,
					},
				},
				navigation: {
					nextEl: [...section.querySelectorAll('.swiper-button-next')],
					prevEl: [...section.querySelectorAll('.swiper-button-prev')],
				},
			});
		});

		const swiperLogos = new Swiper('.swiper--logos', {
			slidesPerView: 'auto',
			spaceBetween: 16,
			autoplay: {
				delay: 3000,
			},
			loop: true,
			breakpoints: {
				1024: {
					spaceBetween: 24,
				},
			},
		});

		const swiperCardLogos = new Swiper('.swiper--c-logos', {
			slidesPerView: 'auto',
			spaceBetween: 16,
			breakpoints: {
				1024: {
					spaceBetween: 24,
				},
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});

		const referencesSwiperElements = document.querySelectorAll('.swiper--references');
		referencesSwiperElements.forEach((swiperElement) => {
			const section = swiperElement.closest('.section');
			const referencesSwiper = new Swiper(swiperElement, {
				slidesPerView: 1,
				loop: true,
				autoHeight: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				pagination: {
					el: section.querySelector(".swiper-pagination"),
					type: "fraction",
				},
				navigation: {
					nextEl: [...section.querySelectorAll('.swiper-button-next')],
					prevEl: [...section.querySelectorAll('.swiper-button-prev')],
				}
			});
		});

		const swiperStepsElements = document.querySelectorAll('.swiper--steps');
		swiperStepsElements.forEach((swiperElement) => {
			const section = swiperElement.closest('.section');
			const swiperSteps = new Swiper(swiperElement, {
				slidesPerView: 'auto',
				spaceBetween: 16,
				loop: false,
				breakpoints: {
					1024: {
						spaceBetween: 24,
						slidesPerView: 2,
					},
				},
				navigation: {
					nextEl: [...section.querySelectorAll('.swiper-button-next')],
					prevEl: [...section.querySelectorAll('.swiper-button-prev')],
				},
			});
		});

		const swiperHistoryElements = document.querySelectorAll('.swiper--history');
		swiperHistoryElements.forEach((swiperElement) => {
			const swiperHistory = new Swiper(swiperElement, {
				slidesPerView: 'auto',
				spaceBetween: 16,
				loop: false,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				breakpoints: {
					1024: {
						spaceBetween: 24,
					},
				},
				navigation: {
					nextEl: [...swiperElement.querySelectorAll('.swiper-button-next')],
					prevEl: [...swiperElement.querySelectorAll('.swiper-button-prev')],
				},
			});
		});
	}
}

const shareButton = {
	init: function () {
		const shareButton = document.getElementById('shareButton');

		if (shareButton && navigator.share) {
			shareButton.style.display = 'inline-flex';

			shareButton.addEventListener('click', function () {
				navigator.share({
					title: document.title,
					text: 'Check out this article!',
					url: window.location.href
				}).then(function () {
				}).catch(function (error) {
					console.error('Error sharing:', error);
				});
			});
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	let matchMedia = gsap.matchMedia();

	animations.init(matchMedia);
	navigation.init(matchMedia);
	navigation.setupDropdown(matchMedia);
	navigation.setupAccordion(matchMedia);
	navigation.hashLinks(matchMedia);
	navigation.stickyTopbar(matchMedia);
	offCanvas.init();
	tabs.init();
	swipers.init(matchMedia);
	shareButton.init();
});

function pageReady(callback) {
	if (document.readyState !== 'loading') {
		callback();
	} else document.addEventListener('DOMContentLoaded', callback);
}

const Button = {
	init: () => {
		Button.rippleEffectMovement();
	},

	rippleEffectMovement: () => {
		const buttonsNodeList = document.querySelectorAll('.btn');
		buttonsNodeList.forEach((btn) => {
			btn.addEventListener('mouseenter', function (e) {
				const rect = this.getBoundingClientRect();
				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;
				const rEffect = document.createElement('span');
				rEffect.classList.add('ripple');

				rEffect.style.left = `${x}px`;
				rEffect.style.top = `${y}px`;

				this.appendChild(rEffect);
				setTimeout(() => {
					rEffect.remove();
				}, 850);
			});
		});
	}
};

pageReady(() => {
	Button.init();
});